import { useTranslation } from 'react-i18next'

import { useDocumentTitle } from '#/shared/lib/document-title'

import { SHIPMENT_STAGES } from '../model/stages'
import type { ShipmentStage } from '../model/stages'

const STAGE_LABEL_KEY: Record<ShipmentStage, string> = {
  [SHIPMENT_STAGES.LEAD]: 'documentTitle.lead',
  [SHIPMENT_STAGES.QUOTE]: 'documentTitle.quote',
  [SHIPMENT_STAGES.ORDER]: 'documentTitle.order',
}

export function useShipmentDocumentTitle(
  stage: ShipmentStage,
  code: string | undefined,
): void {
  const { t } = useTranslation()
  useDocumentTitle(code, t(STAGE_LABEL_KEY[stage]))
}
